import { Navigate, useParams } from 'react-router-dom';
import { useAtom, useAtomValue } from 'jotai';

import {
  ButtonWrapper,
  ContentWrapper,
  Description,
  Footer,
  Name,
  ScrollContainer,
  Wrapper,
} from './index.styles';

import EmailVerificationRoadblock from '../../../../../../common/email_verification_roadblock';
import HeaderWithButton from '../../../../header_with_button';
import ActivateButton from '../../main/coupons/activate_button';

import useI18nText from '../../../../../../../hooks/useI18nText';

import { currentUserState, vendorCardCouponQuery } from '../../../../../../../store';

import type { Coupon } from '@rewardopl/types';

export default function CouponPage() {
  const { coupon_id: couponId } = useParams<{ coupon_id?: Coupon['_id'] }>();

  if (!couponId) {
    throw new Error('couponId is undefined');
  }

  const [coupon, setCoupon] = useAtom(vendorCardCouponQuery(couponId));
  const currentUser = useAtomValue(currentUserState);

  const { description, description_i18n: descriptionI18n, name, name_i18n: nameI18n } = coupon;

  const nameString = useI18nText(nameI18n, name);
  const descriptionString = useI18nText(descriptionI18n, description ?? '');

  if (!coupon) {
    return <Navigate to=".." />;
  }

  const { is_email_verified: isEmailVerified = true } = currentUser;

  return (
    <Wrapper>
      <ScrollContainer>
        <HeaderWithButton>Coupon</HeaderWithButton>
        <ContentWrapper>
          <Name>{nameString}</Name>
          {descriptionString ? <Description>{descriptionString}</Description> : null}
        </ContentWrapper>
      </ScrollContainer>
      <Footer>
        <ButtonWrapper>
          <ActivateButton coupon={coupon} disabled={!isEmailVerified} setCoupon={setCoupon} />
        </ButtonWrapper>
        {isEmailVerified ? null : <EmailVerificationRoadblock />}
      </Footer>
    </Wrapper>
  );
}
